document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll('input[name="Product Type"]')
    .forEach(function (input) {
      input.addEventListener("change", function () {
        if (this.value === "Framed Canvas") {
          document.getElementById("color-variant").style.display = "flex";

          document
            .querySelectorAll("#color-variant input")
            .forEach(function (colorInput, index) {
              colorInput.disabled = false;

              if (index === 0) {
                colorInput.checked = true;
              }
            });
        } else {
          document.getElementById("color-variant").style.display = "none";

          document
            .querySelectorAll("#color-variant input")
            .forEach(function (colorInput) {
              colorInput.disabled = true;
              colorInput.checked = false;
            });
        }
      });
    });
});
